import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const Hero: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section className="relative h-screen flex items-center justify-center overflow-hidden bg-luxury-black">
      {/* Video Background */}
      <video
        className="absolute inset-0 w-full h-full object-cover"
        src="/restaurant_photos/hero_video.mov"
        autoPlay
        loop
        muted
        playsInline
      />
      
      <div className="absolute inset-0 bg-black/50" />

      <div className="relative z-10 text-center text-white section-padding max-w-6xl mx-auto">
        <div className="mb-8">
          <div className="h-px bg-luxury-gold mx-auto mb-8 w-24" />
          
          <p className="text-luxury-champagne text-lg tracking-luxury uppercase font-body mb-4">
            Expérience Unique
          </p>
        </div>

        <h1 className="text-display-xl md:text-6xl lg:text-7xl xl:text-8xl font-display mb-8 text-shadow-luxury">
          PACIFIC <span className="text-white">78</span>
          <br />
          <span className="text-luxury-gold">VELIZY</span>
        </h1>
        
        <p className="text-xl md:text-2xl lg:text-3xl mb-12 font-body font-light text-luxury-champagne max-w-3xl mx-auto leading-relaxed">
          {t('hero.subtitle')}
        </p>

        <div>
          <Link to="/menu">
            <button className="luxury-button group relative">
              <span className="relative z-10">{t('hero.cta')}</span>
              <div className="absolute inset-0 bg-luxury-gold opacity-0 group-hover:opacity-10 transition-opacity duration-500" />
            </button>
          </Link>
        </div>
      </div>

    </section>
  );
};

export default Hero;